export async function parseExportFile(file) {
  const text = await file.text();
  const payload = JSON.parse(text);

  if (!payload || typeof payload !== 'object') {
    throw new Error('Invalid export file');
  }

  return payload;
}

export function validateCollections(payload) {
  const required = ['channels', 'videos', 'subscriptions', 'scans'];
  return required.every((key) => Array.isArray(payload[key]));
}

export function chunkArray(items, size = 500) {
  const chunks = [];
  for (let i = 0; i < items.length; i += size) {
    chunks.push(items.slice(i, i + size));
  }
  return chunks;
}

export function buildExportPayload({ channels, videos, subscriptions, scans }) {
  return {
    exportedAt: new Date().toISOString(),
    version: 1,
    channels,
    videos,
    subscriptions,
    scans
  };
}
